import {assertAndContinue} from 'Asserts';
import * as NavConstants from 'constants/NavConstants';
import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getSelectedPageSize} from 'nav/sidepanel/PageSizeUtil';
import {getEnabledClientOrigins} from 'processes/ProcessConstants';
import {Filter, FilterKey, keyToEmptyFilter, SearchParams} from 'search/SearchConstants';
import * as SearchPreferences from 'search/SearchPreferences';

import {getDefaultTypes} from './processes-search-platform/getAvailableTypes';

export function getDefaultClientOrigin(): ProcessClientOrigin {
  const enabledClientOrigins = getEnabledClientOrigins();
  if (
    !assertAndContinue(
      enabledClientOrigins.length > 0,
      'Expected at least one process client origin to be enabled'
    )
  ) {
    return ProcessClientOrigin.PROCESSES;
  }
  if (enabledClientOrigins.includes(ProcessClientOrigin.PROCESSES)) {
    return ProcessClientOrigin.PROCESSES;
  }
  return enabledClientOrigins[0];
}

export function getDefaultFiltersForClientOrigin(selectedClientOrigin: ProcessClientOrigin): Array<Filter> {
  return [
    {
      ...keyToEmptyFilter(FilterKey.PROCESS_CLIENT_ORIGIN),
      value: selectedClientOrigin,
    },
    {
      ...keyToEmptyFilter(FilterKey.TYPES),
      value: getDefaultTypes(selectedClientOrigin),
    },
  ];
}

export function defaultProcessManagementSearchParams(): SearchParams {
  const defaultClientOrigin = getDefaultClientOrigin();
  const filtersFromUserPreference = SearchPreferences.getAppliedFiltersFromUserPreference(
    NavConstants.Section.PROCESSES
  );
  // Only use the saved user preference filters if they correspond to an enabled client origin - this can happen
  // if flags are flipped on and off.
  const useFiltersFromUserPreference = filtersFromUserPreference.some(
    (filter) =>
      filter.key === FilterKey.PROCESS_CLIENT_ORIGIN &&
      filter.value != null &&
      getEnabledClientOrigins().includes(filter.value as ProcessClientOrigin)
  );
  return {
    filters: useFiltersFromUserPreference
      ? filtersFromUserPreference
      : getDefaultFiltersForClientOrigin(defaultClientOrigin),
    limit: getSelectedPageSize(),
    offset: 0,
    query: '',
    sorts: SearchPreferences.getAppliedSortsFromUserPreference(NavConstants.Section.PROCESSES),
  };
}
